import { InputNumber as AntInputNumber } from "antd";
import type { InputNumberProps } from "antd";

export const InputNumber = (props: InputNumberProps) => {
  return (
    <AntInputNumber
      changeOnWheel={false}
      controls={props?.controls || false}
      type="number"
      onWheel={(e) => e.currentTarget.blur()}
      onScroll={(e) => {
        // Prevent scroll events from changing the value
        e.preventDefault();
        e.stopPropagation();
      }}
      {...props}
    />
  );
};

export default InputNumber;
